var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"clientHistory"}},[_c('client-history-team-component',{ref:"clientHistoryTeamComponent",attrs:{"teamId":_vm.teamId,"showDetail":true,"clientId":_vm.clientId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }